<iq-central-front-end-navbar></iq-central-front-end-navbar>

<div class="container">
    <div id="report-wrapper">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <span class="font20 click mt-5 " (click)="goBack()">
                <i class="fa fa-arrow-left mr-3"></i> Go Back
            </span>
            <span class="font20 click mt-5 d-flex align-items-center" (click)="downloadReport()">
                Download Report

                <i class="fa fa-download ml-2" *ngIf="!isLoading"></i>
                <span class="ml-2"><mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner></span>

            </span>
        </div>

        <div class="report" id="report">
            <div class="course-report-container">
                <div class="report-header">
                    <h1 class="text-center"><strong>Course Report for {{reportData.generatedBy}}</strong></h1>
                </div>

                <!-- Course Information Section -->
                <div class="section">
                    <h2>Course Information</h2>
                    <div class="info-grid">
                        <div class="info-item">
                            <label>Course Title:</label>
                            <span>{{ reportData.courseTitle }}</span>
                        </div>
                        <div class="info-item">
                            <label>Course ID:</label>
                            <span>{{ reportData.courseId }}</span>
                        </div>
                        <div class="info-item">
                            <label>Instructor:</label>
                            <span>{{ reportData.instructor }}</span>
                        </div>
                        <div class="info-item">
                            <label>Date Enrolled:</label>
                            <span>{{ reportData.dateEnrolled | date }}</span>
                        </div>
                        <div class="info-item">
                            <label>Report Generated On:</label>
                            <span>{{ reportData.reportGeneratedOn | date }}</span>
                        </div>
                        <!-- <div class="info-item">
                            <label>Generated By:</label>
                            <span>{{ reportData.generatedBy }}</span>
                        </div> -->
                    </div>
                </div>

                <!-- Progress Overview Section -->
                <div class="section">
                    <h2>1. Progress Overview</h2>
                    <div class="progress-container">
                        <div class="info-grid">
                            <div class="info-item">
                                <label>Course Completion:</label>
                                <span class="progress-text">{{ reportData.courseCompletion }}</span>
                            </div>
                            <div class="info-item">
                                <label>Modules Completed:</label>
                                <span>{{ reportData.modulesCompleted }}</span>
                            </div>
                            <div class="info-item">
                                <label>Last Accessed:</label>
                                <span>{{ reportData.lastAccessed | date }}</span>
                            </div>
                            <div class="info-item">
                                <label>Average Session Duration:</label>
                                <span>{{ reportData.averageSessionDuration }} minutes</span>
                            </div>
                            <div class="info-item">
                                <label>Total Time Spent:</label>
                                <span>{{ reportData.totalTimeSpent }} minutes</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Assessment Performance Section -->
                <div class="section">
                    <h2>2. Assessment Performance</h2>
                    <div *ngIf="reportData.assessmentTaken.length > 0; else noAssessments">
                        <div class="assessment-table">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Assessment Title</th>
                                        <th>Score (%)</th>
                                        <!-- <th>Status</th> -->
                                        <th>Date Taken</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let assessment of reportData.assessmentTaken">
                                        <td>{{ assessment.lessonContentName || 'Assessment' }}</td>
                                        <td>{{ assessment.grade || 0 }}%</td>
                                        <!-- <td>
                                            <span class="status-badge"
                                                [class]="getAssessmentStatusClass(assessment.score)">
                                                {{ getAssessmentStatus(assessment.score) }}
                                            </span>
                                        </td> -->
                                        <td>{{ assessment.createdAt | date: 'medium' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <ng-template #noAssessments>
                        <div class="no-data">
                            <p>No assessments taken yet</p>
                        </div>
                    </ng-template>
                    <div class="assessment-summary">
                        <div class="summary-item">
                            <label>Average Score:</label>
                            <span class="score">{{ reportData.averageScore }}%</span>
                        </div>
                    </div>
                </div>

                <!-- Course Information Section -->
                <div class="section">
                    <h2>Certificate Status</h2>
                    <div class="info-grid">
                        <div class="info-item">
                            <label>Eligible for Certificate:</label>
                            <span>{{ reportData.courseTitle }}</span>
                        </div>
                        <div class="info-item">
                            <label>Date of Certification:</label>
                            <span>{{ reportData.courseId }}</span>
                        </div>
                        <div class="info-item">
                            <label>Certificate ID:</label>
                            <span>{{ reportData.instructor }}</span>
                        </div>
                        <div class="info-item">
                            <label>Download Linkd:</label>
                            <span>{{ reportData.dateEnrolled | date }}</span>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <h2>3. Engagement & Feedback</h2>
                    <div class="info-grid">
                        <div class="info-item">
                            <label>Feedback Rating:</label>
                            <div class="rating" *ngIf="reportData.feedbackRating !== null; else noRating">
                                <span class="rating-score">{{ reportData.feedbackRating }}</span>
                                <div class="stars">
                                    <span *ngFor="let star of getStarsArray(reportData.feedbackRating)" class="star"
                                        [class.filled]="star <= reportData.feedbackRating">★</span>
                                </div>
                            </div>
                            <ng-template #noRating>
                                <span class="no-rating">Not rated</span>
                            </ng-template>
                        </div>
                    </div>
                    <div class="comments-section">
                        <label>Comments:</label>
                        <p class="comment-text">"{{ reportData.feedbackComment }}"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>